module.exports = __webpack_public_path__ + "458e8689a96c211fc57439037d5f41ee.png";